import './App.css';
import {useEffect, useRef, useState} from "react";
import RestServices from "./services/RestServices";
import {LANGUAGES_MAP, LOCALE_MAP} from "./model/languages";
import {StickyTable, Row, Cell} from 'react-sticky-table';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {ReactComponent as ArrowLeftIcon} from './icon/arrow-left.svg';
import {ReactComponent as ArrowRightIcon} from './icon/arrow-right.svg';

function App() {
    const [detail, setDetail] = useState();
    const [language, setLanguage] = useState();
    const [locale, setLocale] = useState();
    const [checkboxValue, setCheckboxVale] = useState();
    const [disableLeft, setDisableLeft] = useState();
    const [disableRight, setDisableRight] = useState();
    const [isThreeColumns, setIsThreeColumns] = useState(false);
    const [showArrow, setShowArrow] = useState(false);

    const tableRef = useRef();

    const {REACT_APP_MODEL_FOLDER} = process.env;

    useEffect(() => {
        (async () => {
            const searchParams = new URLSearchParams(document.location.search);
            let language = searchParams.get("lang");
            if (!language) {
                language = "EN";
            } else {
                language = language.toUpperCase();
            }

            const sizeGuide = searchParams.get("sizeGuide")?.replaceAll(" ", "");
            const sizeClass = searchParams.get("sizeClass")?.replaceAll(" ", "");
            const preview = searchParams.get("previewSizeGuide");

            let modelId;

            if (sizeGuide && sizeGuide !== "null") {
                modelId = sizeGuide
            } else {
                modelId = sizeClass;
            }

            let tableDetail;

            if (preview) {
                tableDetail = await RestServices.getRequest(`${REACT_APP_MODEL_FOLDER}/preview/${preview}.json`);
            } else {
                tableDetail = await RestServices.getRequest(`${REACT_APP_MODEL_FOLDER}/model/${modelId}.json`);
            }
            setCheckboxVale(Object.keys(tableDetail?.radioLabels[LANGUAGES_MAP[language]])[0]);
            setDetail(tableDetail);

            //se non c'è la IT faccio il fallback
            Object.keys(LOCALE_MAP).forEach(item => {
                if (item === language) {
                    if (tableDetail?.header[1]?.[LANGUAGES_MAP?.[item]]?.[LOCALE_MAP?.[item]] || tableDetail?.header[0]?.[LANGUAGES_MAP?.[item]]?.[LOCALE_MAP?.[item]]) {
                        setLocale(LOCALE_MAP[item]);
                    } else {
                        setLocale(LOCALE_MAP["EN"]);
                    }
                }
            })
            setLanguage(language);
        })()
        return () => {
            window.removeEventListener("resize", () => updateButton())
        }
    }, [])

    useEffect(() => {
        if (language) console.log("CURRENT LANGUAGE 🌏 =", language);
    }, [language])

    useEffect(() => {
        if (detail && tableRef.current) {
            const handleScrollOrResize = () => updateButton();

            updateButton();
            // a volte non si aggiorna il fe
            setTimeout(() => {
                updateButton();
            }, 300)

            tableRef.current.addEventListener("scroll", handleScrollOrResize);
            window.addEventListener("resize", handleScrollOrResize);

            return () => {
                tableRef.current?.removeEventListener("scroll", handleScrollOrResize);
                window.removeEventListener("resize", handleScrollOrResize);
            };
        }
    }, [detail]);


    useEffect(() => {
        detail?.header.length === 3 ? setIsThreeColumns(true) : setIsThreeColumns(false);
    }, [detail?.header?.length]);

    const onClickRight = () => {
        tableRef.current.scrollBy({left: 150, behavior: 'smooth'});
    }

    const onClickLeft = () => {
        tableRef.current.scrollBy({left: -150, behavior: 'smooth'});

    }

    const updateButton = () => {
        if (!tableRef.current) return;

        const el = tableRef.current;

        const leftDisabled = el.scrollLeft <= 0;
        const rightDisabled = el.scrollLeft >= (el.scrollWidth - el.clientWidth - 1);

        setDisableLeft(leftDisabled);
        setDisableRight(rightDisabled);
        setShowArrow(!(leftDisabled && rightDisabled));
    };


    return (
        <div className={"container-fluid "}>

            {detail &&
                <>
                    <div className={"sticky-option"}>
                        <div className={" py-1"}>
                            <div className={"wv-select-label"}>{detail?.selectOptions?.label[language]}</div>
                            <select defaultValue={locale}
                                    onChange={(e) => setLocale(e.target.value)}
                                    className="form-select wv-select wv-label"
                                    aria-label="Default select example">
                                {Object.values(detail?.selectOptions?.options[LANGUAGES_MAP[language]]).map((item, i) => (
                                    <option
                                        value={Object.keys(detail?.selectOptions?.options[LANGUAGES_MAP[language]])[i]}>
                                        {item}
                                    </option>
                                ))}

                            </select>
                            <div className={"d-flex my-4 radio"}>
                                {detail?.radioLabels &&
                                    <>
                                        {Object.keys(detail?.radioLabels[LANGUAGES_MAP[language]]).map((item, index) => (
                                            <div
                                                className={index === 1 ? "me-4 d-flex align-items-center right" : "me-4 d-flex align-items-center"}>
                                                <input onClick={() => setCheckboxVale(item)}
                                                       checked={checkboxValue === item}
                                                       className=" wv-input-check custom-checkbox" type="radio"
                                                       name="flexRadioDefault"
                                                       id="flexRadioDefault1"/>
                                                <label className="form-check-label ms-2 wv-label "
                                                       htmlFor="flexRadioDefault1">
                                                    {item.toUpperCase()}
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>

                        {showArrow && (
                            <div className={"d-flex arrow-container w-100"}>
                                <div className={" d-flex position-sticky"}>
                                    <button disabled={disableLeft} className={"btn border-0 p-0 mb-0"}
                                            onClick={onClickLeft}>
                                        <ArrowLeftIcon style={{width: 16, height: 16}}/>
                                    </button>
                                    <button disabled={disableRight} className={"btn border-0 p-0 ms-2 mb-0"}
                                            onClick={onClickRight}>
                                        <ArrowRightIcon style={{width: 16, height: 16}}/>
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>


                    {/* THREE COLUMNS */}
                    <div className={"w-100 mb-4"} style={{display: isThreeColumns ? "block" : "none"}}>
                        <table className="scrollable-table table">
                            <tr>
                                {detail?.header[0]?.[LOCALE_MAP["EN"]] ?
                                    <>
                                        <th style={{top: showArrow ? "93px" : "100px"}}>{detail?.header[0]?.[LOCALE_MAP[language]]}</th>
                                        <th style={{top: showArrow ? "93px" : "100px"}}>{detail?.header[1]?.[LANGUAGES_MAP[language]]?.[locale]}</th>
                                        {detail?.header?.slice(2).map((item, index) => (
                                            <th style={{top: showArrow ? "93px" : "100px"}} className={"capitalize"}
                                                key={index}>{item?.[LOCALE_MAP[language]].toLowerCase()}</th>
                                        ))}
                                    </> :
                                    <>
                                        {detail?.header?.map((item, index) => (
                                            <th style={{top: showArrow ? "93px" : "69px"}}
                                                key={index}>{item?.[LANGUAGES_MAP[language]]?.[locale]}</th>
                                        ))}
                                    </>
                                }
                            </tr>

                            {detail?.header[0]?.[LOCALE_MAP["EN"]] ?
                                <>
                                    {Object.keys(detail?.body)?.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{detail?.order?.[index]}</td>
                                                <td> {detail?.body?.[detail?.order?.[index]]?.["it_size"]?.[locale]}</td>
                                                {Object.values(detail?.body[detail?.order?.[index]]).slice(1).map((item, index) => (
                                                    <td key={index}>{item[checkboxValue]} {checkboxValue === "inch" ? "''" : checkboxValue} </td>
                                                ))}
                                            </tr>
                                        </>
                                    ))}
                                </> :
                                <>
                                    {Object.keys(detail?.body).map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td> {detail?.body[detail?.order[index]]?.["it_size"]?.[locale]}</td>
                                            </tr>
                                        </>
                                    ))}
                                </>
                            }

                        </table>
                    </div>
                    {/*  MULTIPLE COLUMNS */}
                    <div className={"mb-3"} style={{display: isThreeColumns ? "none" : "block"}}>
                        <StickyTable wrapperRef={tableRef}>
                            <Row>
                                {detail?.header[0]?.[LOCALE_MAP["EN"]] ?
                                    <>
                                        <Cell
                                            className={"sticky-header sticky-cell capitalize"}>{detail?.header[0]?.[LOCALE_MAP[language]]}</Cell>
                                        <Cell
                                            className={"sticky-header sticky-cell capitalize"}>{detail?.header[1]?.[LANGUAGES_MAP[language]]?.[locale]}</Cell>
                                        {detail?.header?.slice(2).map((item, index) => (
                                            <Cell
                                                className={`sticky-header capitalize  ${index + 3 === detail?.header?.length ? "sticky-last-head" : "sticky-cell"}`}
                                                key={index}>{item?.[LOCALE_MAP[language]]}</Cell>
                                        ))}
                                    </> :
                                    <>
                                        <>
                                            {detail?.header?.map((item, index) => (
                                                <Cell
                                                    className={`sticky-header capitalize  ${index + 3 === detail?.header?.length ? "sticky-last-head" : "sticky-cell"}`}
                                                    key={index}>{item?.[LANGUAGES_MAP[language]]?.[locale]}</Cell>
                                            ))}
                                        </>
                                    </>
                                }

                            </Row>
                            {Object.keys(detail?.body)?.map((item, index) => (
                                <>
                                    {detail?.header[0]?.[LOCALE_MAP["EN"]] ?
                                        <>
                                            <Row key={index}>
                                                <Cell
                                                    className={`${index + 1 === Object.keys(detail?.body).length ? "sticky-last-row" : "sticky-cell"} `}>{detail?.order[index]}</Cell>
                                                <Cell
                                                    className={`${index + 1 === Object.keys(detail?.body).length ? "sticky-last-row" : "sticky-cell"}`}> {detail?.body?.[detail?.order[index]]?.["it_size"]?.[locale]}</Cell>
                                                {Object.values(detail?.body[item]).slice(1).map((it, i) => (
                                                    <Cell
                                                        className={`${Object.values(detail?.body[item])?.length === i + 2 && index + 1 === Object.keys(detail?.body).length ? "" : Object.values(detail?.body[detail?.order[index]])?.length === i + 2 ? "sticky-last-element" : index + 1 === Object.keys(detail?.body).length ? "sticky-last-row" : "sticky-cell"} `}
                                                        key={i}>{it[checkboxValue]} {checkboxValue === "inch" ? "''" : checkboxValue} </Cell>
                                                ))}
                                            </Row>
                                        </> :
                                        <>
                                            <Row key={index}>
                                                <Cell
                                                    className={`${index + 1 === Object.keys(detail?.body).length ? "sticky-last-row" : "sticky-cell"}`}> {detail?.body[detail?.order[index]]?.["it_size"]?.[locale]}</Cell>
                                            </Row>
                                        </>
                                    }

                                </>
                            ))}

                        </StickyTable>
                    </div>
                </>
            }

        </div>
    );
}

export default App;
